import React, { useState } from "react";
import Select from "react-select";
import { SEC_DataApiPost } from "../../func.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./UpdateStatusSelect.css";

export function UpdateStatusSelect({
  requestId,
  url,
  updateApiCallFunction,
  setActiveOption,
  cardView = false,
  options = [],
}) {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const toastConfig = { autoClose: 4000, position: "top-right" };
  const hasOptions = Array.isArray(options) && options.length > 0;

  async function saveStatus() {
    if (!selectedStatus?.value) {
      toast.error("❌ Please select a status before saving.", toastConfig);
      return;
    }

    if (isSaving) {
      return;
    }

    setIsSaving(true);
    try {
      const payload = {
        requestId,
        statusId: selectedStatus.value,
      };
      const response = await SEC_DataApiPost(url, JSON.stringify(payload));
      const normalisedResponse = normaliseResponse(response);
      const statusCode = normalisedResponse?.statusCode;
      const responseMessage = normalisedResponse?.message;
      const responseData = normalisedResponse?.data;
      const errorMessages = new Set([
        "Unauthorized",
        "Internal Server Error",
        "Bad Request"
      ]);
      if (
        (statusCode && statusCode >= 400) ||
        (responseMessage && errorMessages.has(responseMessage)) ||
        responseData === "error"
      ) {
        toast.error("❌ Failed to update status. Please try again.", toastConfig);
        return;
      }

      if (!statusCode || statusCode === 200) {
        toast.success("✅ Status updated.", toastConfig);
        updateApiCallFunction(requestId);
        setSelectedStatus(null);
        if (setActiveOption) {
          setActiveOption(null);
        }
      } else {
        toast.error("❌ Failed to update status. Please try again.", toastConfig);
      }
    } catch (error) {
      console.error("Error updating status", error);
      toast.error("❌ Failed to update status. Please try again.", toastConfig);
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div className={`update-status-container${cardView ? " update-status-container-card" : ""}`}>
      <Select
        className="update-status-select"
        classNamePrefix="update-status"
        options={options}
        value={selectedStatus}
        onChange={setSelectedStatus}
        placeholder="Select a status"
        isDisabled={isSaving || !hasOptions}
      />
      <button
        type="button"
        className="update-status-save"
        onClick={saveStatus}
        disabled={isSaving || !selectedStatus?.value}
      >
        {isSaving ? "Saving..." : "Save status"}
      </button>
    </div>
  );
}

function normaliseResponse(response) {
  if (!response) {
    return {};
  }
  let parsed = response;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch (_) {
      return { data: parsed };
    }
  }

  if (parsed?.body && typeof parsed.body === "string") {
    try {
      const bodyObj = JSON.parse(parsed.body);
      return { ...parsed, ...bodyObj, body: bodyObj };
    } catch (_) {
      return parsed;
    }
  }

  if (parsed?.body && typeof parsed.body === "object") {
    return { ...parsed, ...parsed.body };
  }

  return parsed;
}
